import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // ✅ Импортируем контекст

const Logout = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { logout } = useAuth(); // ✅ Берём функцию logout из контекста

  useEffect(() => {
    const logoutUser = async () => {
      try {
        await logout(); // контекст сам сделает запрос
        navigate("/login");
      } catch (error) {
        setError(`Ошибка при выходе: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    logoutUser();
  }, [navigate, logout]);

  if (loading) {
    return <p>Загрузка...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return null;
};

export default Logout;
